import * as appActions from '../../src/store/app/actions'
import {connect} from 'react-redux'
import InfoPanel from '../../src/components/info-panel'

function mapStateToProps (state) {
  return {
    infoObj: state.app.infoObj,
  }
}

export default connect(mapStateToProps, {...appActions})(InfoPanel)



// WEBPACK FOOTER //
// ./src/containers/info-panel-container.js